import React from 'react'
import filter from 'lodash/filter'
import StaticQuestionSlide from '../../slides/StaticQuestionSlide'
import { Spring, animated, interpolate, config } from 'react-spring'
import Icon from '../../misc/Icons'
import SyncLiveViewPlayerControlBarSubmitLoading from './SyncLiveViewPlayerControlBarSubmitLoading'

const showCorrectSubmitLoadingTime = 2000
const showGraphSubmitLoadingTime = 500


class SyncLiveViewPlayerControlBarReview extends React.Component{

	constructor(){
		super()
		// this.handleToggleShowCorrect=this.handleToggleShowCorrect.bind(this)
		// this.handleToggleShowGraph=this.handleToggleShowGraph.bind(this)
		// this.state={
	 //   		showCorrectButtonDisabled:false,
	 //   		showGraphButtonDisabled:false,
	 //   		showCorrectSubmitLoading:false,
	 //   		showGraphSubmitLoading:false,
		// }
		// this.showCorrectTimeout=null
		// this.showGraphTimeout=null

	}	


	// handleToggleShowCorrect(){
	// 	if(this.props.revealAnswer){
	// 			return this.props.toggleShowCorrect().then(()=>{
	// 		})
	// 	}
	// 	else{
	// 		if(this.showCorrectTimeout){
	// 			this.setState({showCorrectSubmitLoading:false})
	// 			clearTimeout(this.showCorrectTimeout)
	// 		  this.showCorrectTimeout = null
	// 		}else{
	// 			this.setState({showCorrectSubmitLoading:true})
	// 			this.showCorrectTimeout= setTimeout(() => {
	//         return this.props.toggleShowCorrect().then(()=>{
	// 					this.setState({showCorrectButtonDisabled:false,showCorrectSubmitLoading:false})
	// 					this.showCorrectTimeout = null
	// 			})
	//      }, showCorrectSubmitLoadingTime)
	// 	}
	// 	}
		
	// }

	// handleToggleShowGraph(){
	// 	if(this.props.showGraph){
	// 			return this.props.toggleShowGraph().then(()=>{
	// 		})
	// 	}
	// 	else{
	// 		if(this.showGraphTimeout){
	// 			this.setState({showGraphSubmitLoading:false})
	// 			clearTimeout(this.showGraphTimeout)
	// 		  this.showGraphTimeout = null
	// 		}else{
	// 			this.setState({showGraphSubmitLoading:true})
	// 			this.showGraphTimeout= setTimeout(() => {
	//         return this.props.toggleShowGraph().then(()=>{
	// 					this.setState({showGraphButtonDisabled:false,showGraphSubmitLoading:false})
	// 					this.showGraphTimeout = null
	// 			})
	//      }, showGraphSubmitLoadingTime)
	// 	}
	// 	}
		
	// }




	render(){		

		
			const {questionStage,showGraph,narrowControlBarView,revealAnswer,isSurvey,questionsAndPollsList,playQuestionInSet}=this.props
			const {showCorrectSubmitLoading, showGraphSubmitLoading}=this.props


			return(				
				<React.Fragment>

				

				<div className={'syncLiveView-player-main-controlBar-reviewContainer ' + (questionStage === 'review' ? ' syncLiveView-player-main-controlBar-reviewContainer--show ' : ' syncLiveView-player-main-controlBar-reviewContainer--hide ')}>					
					<div className='syncLiveView-player-main-controlBar-reviewSpacer'/>
					<div className='syncLiveView-player-main-controlBar-reviewSpacer'/>
					<div className='syncLiveView-player-main-controlBar-reviewSpacer'/>
					<button onClick={this.props.toggleScanning} className='syncLiveView-player-main-controlBar-reopenAnswers'>										
						<div className='syncLiveView-player-main-controlBar-reopenAnswers-icon'>										
							<svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">   
							  <path d="M32,11.4280899 L32,23.6478701 C32,25.3932767 30.5664,26.8127053 28.8,26.8127053 L3.2,26.8127053 C1.4336,26.8127053 0,25.3932767 0,23.6478701 L0,11.4280899 C0,9.68110088 1.4336,8.26325472 3.2,8.26325472 L13.6017151,8.26325472 L13.6017151,5.53285714 C13.6017151,5.34350237 13.7552175,5.19 13.9445722,5.19 C14.0313038,5.19 14.1148124,5.2228706 14.1782737,5.28198937 L19.2140344,9.97316474 C19.4449518,10.188281 19.4577611,10.5498627 19.2426448,10.7807802 L14.1814635,15.6193575 C14.0445754,15.750189 13.8275458,15.7452791 13.6967143,15.608391 C13.6357416,15.5445955 13.6017151,15.4597467 13.6017151,15.3714997 L13.6017151,12.50865 L4.47334927,12.50865 C4.34711276,12.50865 4.24477784,12.6109849 4.24477784,12.7372214 L4.24477784,22.6197431 C4.24477784,22.7459796 4.34711276,22.8483145 4.47334927,22.8483145 L27.6616729,22.8483145 C27.7879094,22.8483145 27.8902443,22.7459796 27.8902443,22.6197431 L27.8902443,12.7372214 C27.8902443,12.6109849 27.7879094,12.50865 27.6616729,12.50865 L22.8571429,12.50865 C22.6046698,12.50865 22.4,12.3039802 22.4,12.0515072 L22.4,8.72039758 C22.4,8.46792455 22.6046698,8.26325472 22.8571429,8.26325472 L28.8,8.26325472 C30.5664,8.26325472 32,9.68110088 32,11.4280899 Z" ></path>    
							</svg>
						</div>
						<div className='syncLiveView-player-main-controlBar-reopenAnswers-label'>											
							Reopen
						</div>
					</button>
					 
					<div className='syncLiveView-player-main-controlBar-reviewSpacer'/>
					
					{isSurvey &&
						<div className='syncLiveView-player-main-controlBar-surveyCenterSpacer' />
					}

					{!isSurvey &&
						<button 
							disabled={isSurvey} 
							onClick={this.props.toggleShowCorrect}
							className={'syncLiveView-player-main-controlBar-revealAnswer ' + 
								((revealAnswer && !showCorrectSubmitLoading) ? ' syncLiveView-player-main-controlBar-revealAnswer--active ': '' ) +
								((!revealAnswer && !showCorrectSubmitLoading) ? 'syncLiveView-player-main-controlBar-revealAnswer--preActive ':'') +
								(showCorrectSubmitLoading ? 'syncLiveView-player-main-controlBar-revealAnswer--submitLoading' : '') + 
								(narrowControlBarView ? ' syncLiveView-player-main-controlBar-revealAnswer--narrow ' : '')
							}
						>		
							
							<SyncLiveViewPlayerControlBarSubmitLoading />

							
							{!revealAnswer &&
								<React.Fragment>
									<div className='syncLiveView-player-main-controlBar-revealAnswer-primary'>
										Reveal Answer to Students
									</div>
									<div className='syncLiveView-player-main-controlBar-revealAnswer-secondary'>
										Press <b>ENTER</b> key
									</div>								
								</React.Fragment>
							}

							{revealAnswer &&
								<React.Fragment>
									<div className='syncLiveView-player-main-controlBar-revealAnswer-primary'>
										Answer Revealed
									</div>								
								</React.Fragment>
							}
						</button>
					}

					<div className='syncLiveView-player-main-controlBar-reviewSpacer'/>

					<button onClick={this.props.toggleShowGraph} className={'syncLiveView-player-main-controlBar-showGraph' + ((showGraph && !showGraphSubmitLoading) ? ' syncLiveView-player-main-controlBar-showGraph--active ':' ') +  ((!showGraph && !showGraphSubmitLoading) ? ' syncLiveView-player-main-controlBar-showGraph--preActive  ':' ') + (showGraphSubmitLoading ? ' syncLiveView-player-main-controlBar-showGraph--submitLoading ':' ')}>		
					{/*}
						<div className='syncLiveView-player-main-controlBar-showGraph-icon'>
							<svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
								<path d="M30.0465637,11.7333333 C30.725816,11.7333333 30.9721294,11.8040576 31.2204539,11.936863 C31.4687784,12.0696684 31.6636649,12.2645549 31.7964703,12.5128795 C31.9292757,12.761204 32,13.0075173 32,13.6867697 L32,26.8465637 C32,27.525816 31.9292757,27.7721294 31.7964703,28.0204539 C31.6636649,28.2687784 31.4687784,28.4636649 31.2204539,28.5964703 C30.9721294,28.7292757 30.725816,28.8 30.0465637,28.8 L27.5534363,28.8 C26.874184,28.8 26.6278706,28.7292757 26.3795461,28.5964703 C26.1312216,28.4636649 25.9363351,28.2687784 25.8035297,28.0204539 C25.6707243,27.7721294 25.6,27.525816 25.6,26.8465637 L25.6,13.6867697 C25.6,13.0075173 25.6707243,12.761204 25.8035297,12.5128795 C25.9363351,12.2645549 26.1312216,12.0696684 26.3795461,11.936863 C26.6278706,11.8040576 26.874184,11.7333333 27.5534363,11.7333333 L30.0465637,11.7333333 Z M21.5132303,3.2 C22.1924827,3.2 22.438796,3.27072428 22.6871205,3.40352968 C22.9354451,3.53633508 23.1303316,3.73122162 23.263137,3.97954613 C23.3959424,4.22787065 23.4666667,4.47418397 23.4666667,5.15343634 L23.4666667,26.8465637 C23.4666667,27.525816 23.3959424,27.7721294 23.263137,28.0204539 C23.1303316,28.2687784 22.9354451,28.4636649 22.6871205,28.5964703 C22.438796,28.7292757 22.1924827,28.8 21.5132303,28.8 L19.020103,28.8 C18.3408506,28.8 18.0945373,28.7292757 17.8462128,28.5964703 C17.5978883,28.4636649 17.4030017,28.2687784 17.2701963,28.0204539 C17.1373909,27.7721294 17.0666667,27.525816 17.0666667,26.8465637 L17.0666667,5.15343634 C17.0666667,4.47418397 17.1373909,4.22787065 17.2701963,3.97954613 C17.4030017,3.73122162 17.5978883,3.53633508 17.8462128,3.40352968 C18.0945373,3.27072428 18.3408506,3.2 19.020103,3.2 L21.5132303,3.2 Z M12.979897,8.53333333 C13.6591494,8.53333333 13.9054627,8.60405761 14.1537872,8.73686301 C14.4021117,8.86966842 14.5969983,9.06455495 14.7298037,9.31287946 C14.8626091,9.56120398 14.9333333,9.8075173 14.9333333,10.4867697 L14.9333333,26.8465637 C14.9333333,27.525816 14.8626091,27.7721294 14.7298037,28.0204539 C14.5969983,28.2687784 14.4021117,28.4636649 14.1537872,28.5964703 C13.9054627,28.7292757 13.6591494,28.8 12.979897,28.8 L10.4867697,28.8 C9.8075173,28.8 9.56120398,28.7292757 9.31287946,28.5964703 C9.06455495,28.4636649 8.86966842,28.2687784 8.73686301,28.0204539 C8.60405761,27.7721294 8.53333333,27.525816 8.53333333,26.8465637 L8.53333333,10.4867697 C8.53333333,9.8075173 8.60405761,9.56120398 8.73686301,9.31287946 C8.86966842,9.06455495 9.06455495,8.86966842 9.31287946,8.73686301 C9.56120398,8.60405761 9.8075173,8.53333333 10.4867697,8.53333333 L12.979897,8.53333333 Z M4.44656366,17.0666667 C5.12581603,17.0666667 5.37212935,17.1373909 5.62045387,17.2701963 C5.86877838,17.4030017 6.06366492,17.5978883 6.19647032,17.8462128 C6.32927572,18.0945373 6.4,18.3408506 6.4,19.020103 L6.4,26.8465637 C6.4,27.525816 6.32927572,27.7721294 6.19647032,28.0204539 C6.06366492,28.2687784 5.86877838,28.4636649 5.62045387,28.5964703 C5.37212935,28.7292757 5.12581603,28.8 4.44656366,28.8 L1.95343634,28.8 C1.27418397,28.8 1.02787065,28.7292757 0.779546131,28.5964703 C0.531221616,28.4636649 0.336335083,28.2687784 0.203529679,28.0204539 C0.0707242752,27.7721294 0,27.525816 0,26.8465637 L0,19.020103 C0,18.3408506 0.0707242752,18.0945373 0.203529679,17.8462128 C0.336335083,17.5978883 0.531221616,17.4030017 0.779546131,17.2701963 C1.02787065,17.1373909 1.27418397,17.0666667 1.95343634,17.0666667 L4.44656366,17.0666667 Z"></path>    
							</svg>
						</div>
					*/}
						<div className='syncLiveView-player-main-controlBar-showGraph-graph'>
							<div className='syncLiveView-player-main-controlBar-showGraph-graph-bar syncLiveView-player-main-controlBar-showGraph-graph-bar--1' />
							<div className='syncLiveView-player-main-controlBar-showGraph-graph-bar syncLiveView-player-main-controlBar-showGraph-graph-bar--2' />
							<div className='syncLiveView-player-main-controlBar-showGraph-graph-bar syncLiveView-player-main-controlBar-showGraph-graph-bar--3' />
							<div className='syncLiveView-player-main-controlBar-showGraph-graph-bar syncLiveView-player-main-controlBar-showGraph-graph-bar--4' />
						</div>
						<div className='syncLiveView-player-main-controlBar-showGraph-label'>											
							{showGraph ? 'Hide' : 'Graph'}
						</div>						
						<div className='syncLiveView-player-main-controlBar-showGraph-BG'/>
						<div className='syncLiveView-player-main-controlBar-showGraph-keyboardTooltip'>
									Shift<span className='syncLiveView-player-main-controlBar-showGraph-keyboardTooltip-lighten'>&nbsp;+&nbsp;</span>Enter							
						</div>
					</button>
					<div className='syncLiveView-player-main-controlBar-reviewSpacer'/>
					<div className='syncLiveView-player-main-controlBar-reviewSpacer'/>
					<div className='syncLiveView-player-main-controlBar-reviewSpacer'/>

				</div>		

			</React.Fragment>
				
			)
 
	}
}


export default SyncLiveViewPlayerControlBarReview

